export const BackAltIcon = ({ color = "black", size = 8, ...props }) => (
    <svg
        width={size}
        height={size * (14 / 8)}
        viewBox="0 0 8 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path d="M7 1L0.999993 7.00001L7 13" stroke={color} />
    </svg>
);
